import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfirmPassword, Credentials, Tokens } from '@meddata/interfaces';

import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse } from '@meddata/interfaces/base-response';

@Injectable({
	providedIn: 'root'
})
export class AuthHttpService {
	private readonly baseUrl = environment.apiUrl;
	private readonly http: HttpClient = inject(HttpClient);

	login(credentials: Credentials): Observable<Tokens> {
		return this.http
			.post<BaseResponse<Tokens> | Tokens>(`${this.baseUrl}/login`, null, {
				headers: new HttpHeaders({
					username: credentials.email,
					password: credentials.password
				})
			})
			.pipe(map((res) => this.extractTokens(res)));
	}

	updateToken(token: string): Observable<Tokens> {
		return this.http
			.post<BaseResponse<Tokens> | Tokens>(`${this.baseUrl}/refresh`, null, {
				headers: new HttpHeaders({
					'WWW-Authenticate': token
				})
			})
			.pipe(map((res) => this.extractTokens(res)));
	}

	changePassword(changedPassword: ConfirmPassword): Observable<any> {
		return this.http.post(`${this.baseUrl}/change-password`, {
			newPassword: changedPassword.password
		});
	}

	private extractTokens(response: BaseResponse<Tokens> | Tokens): Tokens {
		if ('auth_token' in response && 'update_token' in response) {
			return response;
		}

		return response.data[0];
	}
}
